import React, { useRef } from "react";
import Slider from "react-slick";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import icon1 from "../assets/image/svg/bi_quote.svg"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


const testimonials = [
  {
    name: "John D",
    role: "Director",
    text: "Booking salon and cleaning services on Vasta . Saved me so much time!",
    rating: 4,
    image: "https://randomuser.me/api/portraits/men/32.jpg",
  },
  {
    name: "Emily R",
    role: "Manager",
    text: "Love how fast I can find reliable professionals . recommend!",
    rating: 4,
    image: "https://randomuser.me/api/portraits/women/44.jpg",
  },
  {
    name: "Anne T",
    role: "CTO",
    text: "Great app for booking appointments and yoga classes. One-stop solution!",
    rating: 5,
    image: "https://randomuser.me/api/portraits/women/65.jpg",
  },
];

const Testimonials = () => {
  const sliderRef = useRef(null);

 const settings = {
  dots: false,
  infinite: true,
  speed: 600,
  slidesToShow: 2, // default: mobile
  slidesToScroll: 1,
  arrows: false,
  responsive: [
    {
      breakpoint: 992, // tablet/laptop
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};



  return (
    <div style={{backgroundColor:"#F2F6FA"}} className=" py-5 overflow-hidden">
      <div className="container">
        {/* Heading Section */}
<div className="row align-items-center">
    <div className="col-md-4">        <h2 className="fw-bold ps-2 ps-md-0 fs_48 text-dark">
          Testimonials from our members
        </h2>
        <p className="text-muted mb-3 ps-2 ps-md-0">
          Embrace life's vastness, venture forth, and discover the wonders
          waiting beyond.
        </p>

        {/* Arrows just below heading */}
        <div className="d-flex gap-2 ps-2 ps-md-0 mb-4">
          <button
            onClick={() => sliderRef.current.slickPrev()}
            className="btn custom d-flex flex-column justify-content-center align-items-center btn-outline-secondary rounded-circle"
          >
            <FaArrowLeft />
          </button>
          <button
            onClick={() => sliderRef.current.slickNext()}
            className="btn custom d-flex flex-column justify-content-center align-items-center btn-outline-secondary rounded-circle"
          >
            <FaArrowRight />
          </button>
        </div></div>

   <div className="col-md-8">
         {/* Slider Section */}
        <Slider ref={sliderRef} {...settings}>
          {testimonials.map((t, i) => (
            <div key={i} className="px-2">
              <div className="card p-md-3 border border-2  shadow-sm h-100  rounded-3">
                <div className="card-body d-flex flex-column">
                    <img width={48} src={icon1} alt="icon1" />
                <p className="card-text mt-3 fst-italic truncate-3" title={t.text}>
  {t.text}
</p>

                  <div className="mt-2 text-success">
                    {Array.from({ length: 5 }).map((_, idx) => (
                      <span key={idx}>{idx < t.rating ? "★" : "☆"}</span>
                    ))}
                  </div>
                  <hr className="borderColor w-100 my-3" />
                  <div className="d-flex align-items-center mt-auto">
                    <img
                      src={t.image}
                      alt={t.name}
                      className="rounded-circle me-3"
                      width={40}
                      height={40}
                    />
                    <div>
                      <h6 className="mb-0 fw-semibold">{t.name}</h6>
                      <small className="text-muted">{t.role}</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
   </div>
</div>
      </div>
    </div>
  );
};

export default Testimonials;
